<template>
  <div class="sld_order_list">
    <MemberTitle memberTitle="Inquiry Records"></MemberTitle>
    <div class="warp2">
      <!-- <h3>询价记录</h3> -->
      <div class="title_search">
        <el-form
          :show-overflow-tooltip="true"
          :inline="true"
          :model="formInline"
          class="title_search_form"
          size="mini"
        >
          <el-form-item class="type_text" :inline="true" label="Contact:">
            <el-input
              v-model="contactName"
              placeholder="Please enter contact"
            ></el-input>
          </el-form-item>

          <el-form-item class="type_text" label="Phone:">
            <el-input
              v-model="contactPhone"
              placeholder="Please enter phone"
            ></el-input>
          </el-form-item>

          <div class="title_search_time">
            <el-form-item label="Request Time:" size="mini" class="type_time">
              <el-date-picker
                style="width: 210px"
                v-model="search_time"
                type="daterange"
                start-placeholder="Start Date"
                end-placeholder="End Date"
              >
              </el-date-picker>
            </el-form-item>
          </div>

          <el-form-item label="Status" class="type_selit">
            <el-select v-model="state" placeholder="Order Status">
              <el-option
                v-for="item in stateList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSearchHistory(1)"
              class="title_subit"
              >Search</el-button
            >
            <el-button type="primary" @click="onReset" class="title_Reset"
              >Reset</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 下方结构表头 -->
      <div class="order_title_info flex_row_start_center list_title">
        <div class="select_name" style="width:140px;font-weight: 700">
          Contact
        </div>
        <div
          class="good_price"
          style="width: 190px;font-weight: 700; margin-left: -66px"
        >
          Phone
        </div>
        <div class="num" style="width: 120px;font-weight: 700 ">Description</div>
        <div
          class="order_price"
          style="width: 180px;font-weight: 700;padding-right: 20px;"
        >
          Image
        </div>
        <div class="state" style="width: 170px;font-weight: 700">Request Time</div>
        <div class="oprate" style="width: 140px;font-weight: 700">Status</div>
        <div class="oprate" style="font-weight: 700; margin-right: 27px">
          Action
        </div>
      </div>
      <!-- 下方结构表格 -->
      <block v-if="order_list.length > 0">
        <div
          class="order_item"
          v-for="(item, index) in order_list"
          :key="index"
        >
          <!-- 联系人 -->
          <div class="order_gg name">{{ item.contactName }}</div>
          <!-- 电话 -->
          <div class="order_gg phone">
            {{ item.contactPhone }}
          </div>
          <!--需求描述  -->
          <div class="order_gg draw">
            <div class="jus">
              <text>{{ item.inquiryDesc }}</text>
            </div>
          </div>
          <!-- 图片 -->
          <div class="order_gg imges">
            <div v-for="(it, idx) in item.goodsImageList" :key="idx">
              <el-image
                class="imgesss"
                :src="it"
                :preview-src-list="item.goodsImageList"
              />
            </div>
          </div>
          <!--时间 -->
          <div class="order_gg time">{{ item.createTime }}</div>
          <!--状态  -->
          <div class="order_gg statess">{{ item.stateValue }}</div>
          <!-- 操作 -->
          <div class="do">
            <div
              class="order_gg"
              v-if="item.state == 3"
              @click="goEdit(item.inquiryId)"
            >
              Republish
            </div>
            <div
              class="order_gg"
              v-else-if="item.state == 1"
              @click="cancellation(item.inquiryId)"
            >
              Close
            </div>
            <div class="order_gg" v-else-if="item.state == 4"></div>
            <div
              class="order_gg"
              @click="getmsg(item.inquiryId)"
              v-else-if="item.isHasReply == '1'"
            >
              View Reply
            </div>
            <div class="order_gg" @click="megInfo(item.inquiryId)">
              Inquiry Details
            </div>
          </div>
        </div>
        <!-- <el-pagination
          layout="prev, pager, next, jumper"
          :page-size="100"
          :total="pageData.total"
          :hide-on-single-page="true"
          class="flex_row_end_center"
        ></el-pagination> -->
        <el-pagination
          @prev-click="handlePrevCilickChange"
          @size-change="handleSizeChange"
          @next-click="handleNextCilickChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.current"
          :page-sizes="[1, 2, 4, 6]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          class="flex_row_end_center"
        >
        </el-pagination>
      </block>

      <block v-else>
        <SldCommonEmpty :tip="'No orders yet~'" totalWidth="74px"
      /></block>
    </div>
    <el-dialog
      title="Reply"
      v-model="dialogVisible"
      width="823px"
      :before-close="handleClose"
      lock-scroll="false"
    >
      <div>
        <ul class="infinite-list" style="overflow: auto">
          <li v-for="(items, indexs) in msgList" :key="indexs" class="hasmsg">
            <div class="msg_title">
              <div>{{ items.factoryName }}</div>
              <div>{{ items.replyTime }}</div>
            </div>
            <div class="msg_main">
              <div class="msg_main_title">
                <div>Price: ${{ items.goodsPrice }}</div>
                <div>Deposit Ratio: {{ items.depositRatio }}%</div>
                <div>Expected Delivery: {{ items.deliveryTime }}</div>
              </div>
              <div class="msg_main_cont">
                <text>Reply Content:</text>
                <div class="msg_content">{{ items.replyContent }}</div>
              </div>
              <div class="msg_main_img">
                <text>Images:</text>
                <div
                  class="img_fa"
                  v-for="(itx, idxx) in items.replyImages"
                  :key="idxx"
                >
                  <!-- <img :src="itx" alt="" /> -->
                  <el-image
                    class="imgesss"
                    :src="itx"
                    :preview-src-list="items.replyImages"
                    :initial-index="0"
                    fit="cover"
                  />
                </div>
              </div>
            </div>
            <div
              class="bten"
              @click="luyong(items.replyId)"
              v-if="items.state != '5'"
            >
              Accept
            </div>
          </li>
        </ul>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >Confirm</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted, reactive } from 'vue'
import MemberTitle from '../../../components/MemberTitle'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import SldCommonEmpty from '../../../components/SldCommonEmpty'
export default {
  components: {
    MemberTitle,
    SldCommonEmpty
  },
  setup () {
    const router = useRouter()
    const { proxy } = getCurrentInstance()
    const stateList = ref([
      {
        value: '1',
        label: 'Pending Review'
      },
      {
        value: '2',
        label: 'Approved'
      },
      {
        value: '3',
        label: 'Rejected'
      },
      {
        value: '4',
        label: 'Closed'
      },
      {
        value: '5',
        label: 'Accepted'
      }
    ]) //状态数组
    const stateNamer = ref('') //存储订单状态
    const search_time = ref('') //顶部选择的时间
    const contactName = ref('') //联系人姓名
    const contactPhone = ref('') //联系人电话
    const state = ref('') //询价单状态
    const order_list = ref([]) //订单列表
    const pageData = reactive({
      current: 1,
      pageSize: 6,
      total: 0
    })
    const dialogVisible = ref(false) //查看回复弹窗
    const msgList = ref([]) //查看回复弹窗
    //组件时间处理
    const playTime = time => {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      let times = y + '-' + m + '-' + d //这里如果不需要小时 分  后边的可以不需要拼接
      return times
    }
    //     搜索点击事件
    const onSubmit = () => {
      let param = {}
      param.current = pageData.current
      param.pageSize = pageData.pageSize
      if (search_time.value) {
        let startTime = playTime(search_time.value[0])
        let endTime = playTime(search_time.value[1])
        if (startTime) {
          param.startTime = startTime
        }
        if (endTime) {
          param.endTime = endTime
        }
      }
      if (contactName.value) {
        param.contactName = contactName.value
      }
      if (contactPhone.value) {
        param.contactPhone = contactPhone.value
      }
      if (state.value) {
        param.state = state.value
      }

      proxy.$get('/v3/goods/front/goods/inquiry/list', param).then(res => {
        if (res.state == 200) {
          order_list.value = res.data.list
          pageData.total = res.data.pagination.total
        } else {
          ElMessage(res.msg)
        }
      })
    }
    //点击重置按钮事件
    const onReset = () => {
      //       console.log(contactName, contactPhone, state);
      contactName.value = ''
      contactPhone.value = ''
      state.value = ''
      search_time.value = ''
    }
    //获取订单列表
    const getOrderList = () => {
      let param = {}
      param.pageSize = 6
      proxy.$get('/v3/goods/front/goods/inquiry/list', param).then(res => {
        console.log('res---这个哇哦---', res)
        if (res.state == 200) {
          order_list.value = res.data.list
          pageData.total = res.data.pagination.total
        } else {
          ElMessage(res.msg)
        }
      })
    }
    //跳转重新编辑
    const goEdit = inquiryId => {
      router.push({
        path: '/member/xuenjia/fabuxuenjia',
        query: {
          inquiryId: inquiryId
        }
      })
    }
    //点击条每页事件事件
    const handleSizeChange = index => {
      pageData.pageSize = index
      onSubmit()
    }
    //向前翻页
    const handlePrevCilickChange = e => {
      pageData.current = e
      onSubmit()
    }
    //向后翻页
    const handleNextCilickChange = () => {
      pageData.current++
      onSubmit()
    }
    //页数改变
    const handleCurrentChange = current => {
      pageData.current = current
      onSubmit()
    }
    /* 询价记录搜索事件 */
    const onSearchHistory = current => {
      pageData.current = current
      onSubmit()
    }

    //取消订单
    const cancellation = inquiryId => {
      ElMessageBox.confirm('Close inquiry?', 'Tip', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          proxy
            .$post('/v3/goods/front/goods/inquiry/close', {
              inquiryId
            })
            .then(res => {
              if (res.state == 200) {
                ElMessage.success('Inquiry closed successfully')
                onSubmit()
              } else {
                ElMessage(res.msg)
              }
            })
            .catch(() => {
              //异常处理
            })
        })
        .catch(() => {})
    }
    // 点击查看回复事件
    const getmsg = inquiryId => {
      let form = {}
      form.inquiryId = inquiryId
      proxy.$get('/v3/goods/front/goods/inquiry/seeReply', form).then(res => {
        if (res.state == 200) {
          msgList.value = res.data.list
          dialogVisible.value = true
        } else {
          ElMessage(res.msg)
        }
      })
    }

    // 查看询价详情
    const megInfo = inquiryId => {
      router.push({
        path: '/member/xuenjia/xuenjiainfo',
        query: {
          inquiryId: inquiryId
        }
      })
    }

    // 点击录用事件
    const luyong = replyId => {
      proxy
        .$post('/v3/goods/front/goods/inquiry/confirmEmploy', { replyId })
        .then(res => {
          console.log(res)
          if (res.state == 200) {
            router.push({
              path: '/buy/comformorder',
              query: {
                replyId: replyId
              }
            })
          } else {
            ElMessage(res.msg)
          }
        })
    }

    onMounted(() => {
      getOrderList()
    })

    onBeforeRouteLeave(() => {
      document.body.style.overflow = 'visible'
    })

    return {
      stateNamer,
      order_list,
      stateList,
      contactName,
      contactPhone,
      state,
      search_time,
      pageData,
      dialogVisible,
      msgList,
      getOrderList,
      onSubmit,
      onReset,
      playTime,
      goEdit,
      handleSizeChange,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      cancellation,
      getmsg,
      megInfo,
      luyong,
      onSearchHistory
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/xuebjiajilu.scss';
</style>
